import axios from "axios";
import router from '../router/index'

// 请求域名
const baseURL = 'https://yqcq9291.com'
// const baseURL = 'https://rk88.vip'

// 创建 axios 请求实例
const createQequest = () => {
    // axios 请求实例
    const instance = axios.create({
        baseURL: baseURL + "/api",
        timeout: 30000,
    });

    // 请求拦截器
    instance.interceptors.request.use(
        async (config) => {
            const token = localStorage.getItem('token')
            const lang = localStorage.getItem('lang') || 'ms_my'
            config.headers['Accept-Language'] = lang
            token && (config.headers.token = token)
            return config;
        },
        (error) => { return Promise.reject(error) }
    );

    // 响应拦截器
    instance.interceptors.response.use(
        (response) => {
            const { code } = response.data;
            if (code === 402 || code === 1001) {
                localStorage.removeItem("token");
                const currPath = router.history.current.path
                if (currPath !== '/login') {
                    router.replace('/login')
                }
            }
            return Promise.resolve(response.data);
        },
        (error) => {
            // console.log(error);


            return Promise.resolve({
                code: error.status,
                data: {},
                msg: 'error'
            });
        }
    );

    return instance
}
// 图片上传
const imgUpload = async (file) => {
    const formData = new FormData()
    formData.append("file", file)
    const url = baseURL + "/api"
    const token = localStorage.getItem('token')
    if (!token) return
    const headers = {
        'Content-Type': 'multipart/form-data',
        token,
    }
    const res = await axios.post(url, formData, { headers })
    return res.data
}

const request = createQequest()

// 请求列表
const http = {
    getSystemConfig: () => request({ // 获取系统配置
        url: '/system1/getsystemconfig',
    }),
    login: (data) => request({ // 登录
        url: '/member/login',
        method: 'post',
        data,
    }),
    register: (data) => request({ // 注册
        url: '/member/register',
        method: 'post',
        data,
    }),
    getSwipeList: () => request({ // 获取轮播图列表
        url: '/system/getbannerlist',
    }),
    getProductList: (data) => request({ // 获取产品列表
        url: '/product/getproductlist',
        method: 'post',
        data,
    }),
    getVipList: () => request({ // 获取 vip 列表
        url: '/member/getmemberlevels',
    }),
    getSchedule: () => request({ // 获取抢单进度
        url: '/order/getMissionProgress',
    }),
    startGrabOrder: () => request({ // 开始抢单
        url: '/order/processingOrder',
    }),
    placeOrder: () => request({ // 下单
        url: '/order/placeOrder',
    }),
    getOrderRecord: (data) => request({ // 获取订单列表
        url: '/order/orderList',
        method: 'post',
        data,
    }),
    getFundRecord: (data) => request({ // 获取资金流水
        url: '/order/moneyLogList',
        method: 'post',
        data,
    }),
    getUserInfo: () => request({ // 获取会员信息
        url: '/member/getuserinfo',
    }),
    withdraw: (data) => request({ // 提现
        url: '/withdraw/apply',
        method: 'post',
        data,
    }),
    getWithdrawRecord: (data) => request({ // 获取提现记录
        url: '/withdraw/lists',
        method: 'post',
        data,
    }),
    getRechargeRecord: (data) => request({ // 获取充值记录
        url: '/recharge/lists',
        method: 'post',
        data,
    }),
    bindCard: (data) => request({ // 绑定银行卡
        url: '/bank/updateBankCard',
        method: 'post',
        data,
    }),
    getBankCardDetail: (data) => request({ // 获取会员银行卡详情
        url: '/bank/getBankCardDetail',
        method: 'post',
        data,
    }),
    changeWithdrawPsd: (data) => request({ // 修改提现密码
        url: '/member/setpaypassword',
        method: 'post',
        data,
    }),
    changeLoginPsd: (data) => request({ // 修改登录密码
        url: '/member/setloginpassword',
        method: 'post',
        data,
    }),
    getPrivacyPolicy: () => request({ // 获取隐私政策
        url: '/article/getdetail',
        method: 'post',
        data: { id: 1 },
    }),
    getTermsOfUse: () => request({ // 获取使用条款
        url: '/article/getdetail',
        method: 'post',
        data: { id: 2 },
    }),
    getPopupNotification: () => request({ // 获取弹窗信息
        url: '/member_notification/getPopupNotification',
    }),
    getMsgList: (data) => request({ // 获取信息列表
        url: '/member_notification/list',
        method: 'post',
        data,
    }),
    getMsgDetail: (data) => request({ // 获取信息列表
        url: '/member_notification/detail',
        method: 'post',
        data,
    }),
    imgUpload, // 图片上传
}

export default http